/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Display_Locale_ErrorInputs */



/**
* | output |
* | --- |
* | "Couldn't save your display language" |
*
* @param {Profile_Display_Locale_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const profile_display_locale_error = /** @type {((inputs?: Profile_Display_Locale_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Display_Locale_ErrorInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deine Anzeigesprache konnte nicht gespeichert werden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer votre langue d'affichage")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("无法保存你的显示语言")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("無法儲存你的顯示語言")
	if (locale === "ko") return /** @type {LocalizedString} */ ("표시 언어를 저장하지 못했습니다")
	return /** @type {LocalizedString} */ ("Couldn't save your display language")
});